import { STAR } from "./ZodiacWheel";

export const Marquee = ({ items, testId = "marquee", className = "", fast = false }) => {
  const row = [...items, ...items];
  return (
    <div data-testid={testId} className={`relative overflow-hidden border-y border-[#D4AF37]/15 bg-[#0B0716] py-6 ${className}`}>
      <div className={`flex w-max ${fast ? "animate-marquee-fast" : "animate-marquee"}`}>
        {row.map((t, i) => (
          <span key={i} className="font-display flex items-center whitespace-nowrap px-6 text-3xl italic text-slate-300/90 sm:text-5xl">
            {t}
            <svg viewBox="0 0 24 24" className="ml-12 h-5 w-5 text-[#D4AF37]" aria-hidden="true"><path d={STAR} fill="currentColor" /></svg>
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0B0716] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0B0716] to-transparent" />
    </div>
  );
};
